import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// If the page was navigated to via the header's forced full reload/navigation
// (which appends ?fromLogo=1 or ?fromNav=1 or sets session flags), ask the
// browser not to restore the previous scroll position so our manual
// scroll-to-top can take effect. Doing this very early reduces race conditions.
try {
  const params = new URLSearchParams(window.location.search);
  const fromNav = params.get('fromNav') === '1' || sessionStorage.getItem('fromNav') === '1';
  const fromLogo = params.get('fromLogo') === '1' || sessionStorage.getItem('fromLogo') === '1';
  if (fromNav || fromLogo) {
    if ('scrollRestoration' in window.history) {
      try { window.history.scrollRestoration = 'manual'; } catch (e) { /* ignore */ }
    }
  }
} catch (e) { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

